/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withStyles, Button } from '@material-ui/core';
import AppContext from '../AppContext';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #dddddd'
    },

    link: {
        padding: theme.spacing.unit * 2,
        borderBottom: '1px solid #dddddd',
        color: '#000',
        textDecoration: 'none'
    }
});

class Nav extends Component {
    constructor(props) {
        super(props);

        this.state = {
            links: []
        };
    }

    componentDidMount() {
        AppContext.getUser()
            .then((user) => {
                let links = [
                    {
                        to: '/',
                        label: this.props.t('Etusivu'),
                    },

                    {
                        to: '/overview',
                        label: this.props.t('Raportointi'),
                        visible: () => (AppContext.isAdmin() ||
                            (user.organisation && !user.organisation.export_disabled) ||
                            (user.restaurant && !user.restaurant.export_disabled))
                    },

                    {
                        to: '/organisations',
                        label: this.props.t('Organisaatiohallinta'),
                        admin: true
                    },

                    {
                        to: '/restaurants',
                        label: this.props.t('Toimipaikkahallinta'),
                        admin: true
                    },

                    {
                        to: '/settings',
                        label: this.props.t('Ruokakategoriat'),
                        admin: true
                    },

                    {
                        to: '/food-service-categories',
                        label: this.props.t('Ravintolatyypit'),
                        admin: true
                    },

                    {
                        to: '/feedback-reports',
                        label: this.props.t('Palauteraportointi'),
                    },

                    {
                        to: '/feedback-questions',
                        label: this.props.t('Palautekysymykset'),
                        admin: true
                    },

                    {
                        to: '/user',
                        label: this.props.t('Käyttäjätiedot'),
                    },

                    {
                        href: 'https://youtube.com/embed/8vpqXh1Ud1E',
                        label: this.props.t('Ohjevideo'),
                    },

                    {
                        to: '/logout',
                        label: this.props.t('Kirjaudu ulos'),
                    }
                ];

                // Add my organisation link for organisation users
                if (AppContext.isOrganisation()) {
                    links.splice(3, 0, {
                        to: `/organisations/${user.organisation.id}`,
                        label: this.props.t('Organisaatio'),
                        organisation: true
                    });
                }

                this.setState({ links });
            });

    }

    renderNavItems() {
        const { classes } = this.props;

        return this.state.links.map((item, i) => {
            let button;
            if (item.to) {
                button = (<Button key={i} component={Link} to={item.to} className={classes.link}>
                    {item.label}
                </Button>);
            } else if (item.href) {
                button = (<Button key={i} href={item.href} target="_blank" rel="noopener noreferrer" className={classes.link}>
                    {item.label}
                </Button>);
            }

            return ((!item.visible || item.visible()) && (!item.admin || AppContext.isAdmin())) && button;
        });
    }

    render() {
        const { classes } = this.props;
        const items = this.renderNavItems();

        return (
            <div className={classes.container}>
                {items}
            </div>
        );
    }
}


export default withTranslation()(withStyles(styles)(Nav));



// WEBPACK FOOTER //
// ./resources/assets/js/components/Nav.js